/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:04
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-02-18 14:31:02
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\doctor\index.js
 */
import state from './state'
import mutations from './mutations'
import actions from './actions'
export default {
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions
}
